// extracted by mini-css-extract-plugin
module.exports = {"list":"styles_list__3tbwd","columns":"styles_columns__2YJgU","column":"styles_column__2UCID","done":"styles_done__3Uq6B"};